import React, { useCallback, useRef, useState } from 'react'
import { z } from 'zod';

const schema = z.object({
    email: z.string().email()
});

function EmailList({ isEditable, emailList, onRemoveEmail, onAddEmail, errorMessage }) {
    const [isInputVisible, setInputVisible] = useState(false);
    const [localError, setLocalError] = useState('');
  
    const emailInputRef = useRef(null);
    const inputRef = useRef(null);

    const renderInputLabel = useCallback(() => {
        return (
            <div className='email-input' onClick={() => setInputVisible(true)} style={{padding: '12px 13px', width: '100%'}}>
                <span>{emailList[0]}</span>
        
                {emailList.length > 1 && <span style={{cursor: 'pointer'}} className='bg-light ml-2 p-1 text-dark'>+{emailList.length - 1} more</span>}
            </div>
        );
    }, [emailList]);

    const handleChange = () => {
        const validation = schema.safeParse({ email: inputRef.current.value });
        
        if (!validation.success) {
           return setLocalError(validation.error.issues[0].message)
        }

        setLocalError('');
    };

    const handleSubmit = (event) => {
        if (event.key !== 'Enter' || !inputRef.current || localError) return;
        
        event.preventDefault();
        
        const email = inputRef.current.value;
        onAddEmail(email);
        
        inputRef.current.value = '';
    };

    const error = localError || errorMessage;
  
    return (
        <div className='mb-3'>
            <div ref={emailInputRef} style={{columnGap: '0.6rem'}} className='d-flex border flex-wrap align-items-center'>
                {isEditable && (isInputVisible || emailList.length === 0) ? (
                    <>
                        {emailList.map((email, index)=> (
                            <div key={email} className={`badge badge-pill badge-light text-lowercase ${index === 0 ? 'ml-2' : ''}`}>
                                <span className='d-flex align-items-center'>
                                    <span>{email}</span>
            
                                    <button 
                                        type="button" 
                                        className="close ml-1" 
                                        data-dismiss="modal" 
                                        aria-label="Close"
                                        onClick={() => onRemoveEmail(email)}
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </span>
                            </div>
                        ))}
                        
                        <div style={{ flexGrow: 1 }}>
                            <input
                                autoFocus
                                type='email'
                                placeholder={emailList.length === 0 ? 'To' : undefined}
                                className='form-control border-0 '
                                ref={inputRef}
                                onChange={handleChange}
                                onKeyDown={handleSubmit}
                            />
                        </div>
                    </>
                ) : renderInputLabel()
            }
            </div>

            {error
                ? <div className="text-danger small mt-1">{error}</div> 
                : <span style={{fontSize: '0.815rem'}} className="mt-1 d-block text-capitalize">Note: Press enter key after inputting each email</span>}
        </div>
    )
}

export default EmailList